import React from 'react';
import type { CueName } from '@foleyjs/core';

type CardValue = string | number;

interface CardProps {
  value: CardValue;
  onClick?: () => void;
  isSelected?: boolean;
  showValue?: boolean;
  disabled?: boolean;
  className?: string;
  /** Foley cue played on click. Omit for the non-interactive cards on the table. */
  clickCue?: CueName;
  /** Foley cue played on pointer enter. */
  hoverCue?: CueName;
  /** Semitones to transpose `hoverCue` by, so a row of cards can rise in pitch. */
  hoverPitch?: number;
}

const Card: React.FC<CardProps> = ({
  value,
  onClick,
  isSelected = false,
  showValue = false,
  disabled = false,
  className = '',
  clickCue,
  hoverCue,
  hoverPitch,
}) => {
  const classes = ['card', className.trim()];
  classes.push(showValue ? 'card--revealed' : 'card--hidden');
  if (isSelected) {
    classes.push('card--selected');
  }

  return (
    <button
      type="button"
      className={classes.filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={disabled}
      data-foley-click={clickCue}
      data-foley-hover={hoverCue}
      data-foley-hover-pitch={hoverPitch}
    >
      <span className="card__value" aria-hidden={!showValue}>
        {showValue ? value : ''}
      </span>
    </button>
  );
};

export default Card;
